var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconUpload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 31,
    viewBox: "0 0 27 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.5299 10.2281C21.1317 10.6108 20.4861 10.6108 20.0879 10.2281L15.6657 5.97777L15.6657 20.9243C15.6657 21.4765 15.218 21.9243 14.6657 21.9243H13.3324C12.7801 21.9243 12.3324 21.4765 12.3324 20.9243L12.3324 5.47591L7.84543 9.78842C7.19456 10.414 6.13928 10.414 5.48841 9.78842C4.83753 9.16284 4.83753 8.14859 5.48841 7.52302L11.3809 1.85956L11.3808 1.85948L13.0169 0.287032C13.307 0.008205 13.7284 -0.0674795 14.0898 0.0599781C14.2245 0.107462 14.3508 0.183162 14.459 0.28708L16.095 1.85952L16.095 1.85956L22.445 7.96272C22.8431 8.34543 22.8431 8.96592 22.445 9.34863L21.5299 10.2281ZM0 26.9373H26.6667V30.2706H0V26.9373Z",
    fill: "#CED3DC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconUpload);
export default __webpack_public_path__ + "static/media/IconUpload.3c09020e708de595b2d8847364a99579.svg";
export { ForwardRef as ReactComponent };